import { render, staticRenderFns } from "./ModalCadastroTitulacao.vue?vue&type=template&id=5290c076"
import script from "./ModalCadastroTitulacao.vue?vue&type=script&lang=js"
export * from "./ModalCadastroTitulacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports